module.exports = __webpack_public_path__ + "img/020078.6346c846.png";